<div class="flex column align-items-center step-layout">
  <div class="step-layout__content">
    <div class="flex column align-items-center gap-32">
      <div class="flex column align-items-center gap-4">
        <span class="typo-title-3 p-4">Recovery Phrase</span>
        <span class="typo-text-2 text-medium text-align-center"
          >This recovery phrase is the only way to restore your wallet.
          <strong>Do NOT share it with anyone.</strong></span
        >
      </div>
      <div class="flex column align-items-center gap-24 full-width">
        <div class="flex gap-24 justify-content-start full-width">
          <app-radio-input
            [value]="12"
            [selected]="wordCount()"
            (selectedChange)="onWordCountChange($event)"
          >
            <span class="typo-text-3">12 words</span>
          </app-radio-input>
          <app-radio-input
            [value]="24"
            [selected]="wordCount()"
            (selectedChange)="onWordCountChange($event)"
          >
            <span class="typo-text-3">24 words</span>
          </app-radio-input>
        </div>
        <div class="seed-container">
          @for (item of seedPhrase(); track $index) {
            <app-seed-phrase-word
              class="seed-container__word"
              [idx]="$index + 1"
              [word]="item"
            />
          }
        </div>
        <div class="flex full-width justify-content-between">
          <kc-button
            [variant]="'secondary'"
            [suffixIcon]="'icon-copy'"
            [text]="'Copy'"
            (buttonClick)="addToClipboard()"
          >
            <div rightSideSlot>foo</div>
          </kc-button>
          <kc-button
            [variant]="'secondary'"
            [suffixIcon]="'icon-update'"
            [text]="'Renew'"
            (buttonClick)="renewSeedPhrase()"
          >
            <div rightSideSlot>foo</div>
          </kc-button>
        </div>
      </div>
    </div>
  </div>

  <div class="step-layout__buttons">
    <div class="flex justify-content-start full-width pb-16">
      <app-checkbox-input
        [checked]="seedPhraseSaved()"
        (checkedChange)="onSeedPhraseSavedChange($event)"
      >
        <span class="typo-text-3">I saved my recovery phrase</span>
      </app-checkbox-input>
    </div>

    <div class="flex full-width gap-16">
      @if (!hideBackButton()) {
        <div class="full-width">
          <kc-button
            [isFullWidth]="true"
            [variant]="'secondary'"
            [text]="'Back'"
            [isDisabled]="false"
            (buttonClick)="previous.emit()"
          />
        </div>
      }
      <div class="full-width">
        <kc-button
          [isFullWidth]="true"
          type="submit"
          [text]="'Continue'"
          [isDisabled]="!seedPhraseSaved()"
          (buttonClick)="onContinue()"
        />
      </div>
    </div>
  </div>
</div>
